import { IVertexAttribute } from "../types";

/**
 * Makes it easier to type out and get better editor help in establishing initShader
 */
export function createVertex(options: IVertexAttribute) {
  return options;
}
